const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8050';

const request = async (path, options = {}) => {
  const response = await fetch(`${API_BASE_URL}/api/v1/auth${path}`, {
    ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {})
    }
  });

  if (response.status === 204) return null;
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.detail || 'Authentication request failed');
  }
  return payload;
};

export const getCurrentUser = () => request('/me');

export const registerUser = (details) => request('/register', {
  method: 'POST',
  body: JSON.stringify(details)
});

export const loginUser = (details) => request('/login', {
  method: 'POST',
  body: JSON.stringify(details)
});

export const updateLearningPaths = (learningPaths) => request('/learning-paths', {
  method: 'PUT',
  body: JSON.stringify({ learning_paths: learningPaths })
});

export const submitOnboardingIntent = (intent) => request('/onboarding-intent', {
  method: 'POST',
  body: JSON.stringify(intent)
});

export const verifyEmail = (token) => request(`/verify-email?token=${encodeURIComponent(token)}`);

export const resendVerificationEmail = () => request('/resend-verification', { method: 'POST' });

export const logoutUser = () => request('/logout', { method: 'POST' });
